import React, { Component } from 'react';
import Page from './page';
import AppBar from '../common/AppBar';
import {
    setItemStorage, getItemStorage,
} from '../../utils/LocalStorageManager';
import {
    GetSocios, PostSocio
} from '../../utils/SocioManager';
import {
    UsuarioLogueado
} from '../../utils/UserManager';
import MaterialTable from 'material-table';


class Alumnos extends Component {
    constructor(props) {
        super(props);
        this.state = {socios :[],show:false}
        this.goTo = this.goTo.bind(this);
    }

    componentDidMount() {
    
        if(!UsuarioLogueado()){
            window.location.href = "/login";
        } else{
     
     this.setState({ show:true})
    }
    }

    goTo(path) {
        this.props.history.push(path);
    }

    render() {
        const {
            currentItem,
        } = this.props;

        return (
            <React.Fragment>
            <AppBar DrawerOpenedDefault={true} goTo={this.goTo} path='/socios' />
            {this.state.show &&<Page
                currentItem={currentItem}
                socios={this.state.socios}
                onCreate={PostSocio}
                goTo={this.goTo}
            />}
            {!this.state.show && <span>Cargando socios...</span>}
            </React.Fragment>
        );
    }
}


export default Alumnos;